import { Banner, Link } from '@customerio/pluma-components/react';
import { useStore } from '@nanostores/react';
import { BILLING_PATHS, usePauseSafePermission } from '@/features/billing';
import { accountStore } from '@/services/auth/store';

function PausedAccountContent() {
  // A paused account has no write access, but its admins must still be able to unpause it.
  const canEditBilling = usePauseSafePermission('account/billing/edit');

  return (
    <Banner
      type="announcement"
      variant="caution"
      title="Your account has been paused"
      description={
        canEditBilling ? (
          <>
            Your Essentials plan will reactivate after 3 billing cycles or you can{' '}
            <Link href={BILLING_PATHS.overview} variant="secondary">
              reactivate now
            </Link>
            .
          </>
        ) : (
          'Contact an admin to unpause your account.'
        )
      }
      data-test-paused-account-banner
    />
  );
}

/** Tells a paused account when it reactivates, and links an admin to reactivate it now. */
export function PausedAccountBanner() {
  const account = useStore(accountStore);

  if (account?.is_paused !== true) {
    return null;
  }
  return <PausedAccountContent />;
}
